import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { IconButton, Tooltip } from "@material-ui/core";
import { InfoOutlined as InfoIcon } from "@material-ui/icons";

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;

const LabelWithHelp = ({ children, label, helpText, placement, ariaLabel }) => {
  const labelContent = label || children;

  return (
    <Container>
      {labelContent}
      <Tooltip title={helpText} placement={placement}>
        <IconButton aria-label={ariaLabel} size="small">
          <InfoIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Container>
  );
};

LabelWithHelp.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  label: PropTypes.string,
  helpText: PropTypes.string.isRequired,
  placement: PropTypes.string,
  ariaLabel: PropTypes.string
};

LabelWithHelp.defaultProps = {
  children: null,
  label: null,
  placement: "right",
  ariaLabel: "Mais informações"
};

export default LabelWithHelp;
